import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileMenu", "backdrop", "closeButton"]

  connect() {
    this.isOpen = false
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true
    this.mobileMenuTarget.classList.remove("hidden")

    // アニメーション効果を追加
    setTimeout(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.backdropTarget.classList.add("opacity-100")

      const sidebarPanel = this.mobileMenuTarget.querySelector('.relative')
      sidebarPanel.classList.remove("-translate-x-full")
      sidebarPanel.classList.add("translate-x-0")
    }, 10)
  }

  close() {
    this.isOpen = false

    // アニメーション効果
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")

    const sidebarPanel = this.mobileMenuTarget.querySelector('.relative')
    sidebarPanel.classList.remove("translate-x-0")
    sidebarPanel.classList.add("-translate-x-full")

    // アニメーション完了後に非表示
    setTimeout(() => {
      this.mobileMenuTarget.classList.add("hidden")
    }, 300)
  }

  // バックドロップクリックで閉じる（修正版）
  closeOnBackdrop(event) {
    // バックドロップ要素またはその子要素がクリックされた場合
    // ただし、サイドバーパネル内のクリックは除外
    const sidebarPanel = this.mobileMenuTarget.querySelector('.relative')

    if (!sidebarPanel.contains(event.target)) {
      this.close()
    }
  }

  // サイドバー内のクリックイベントの伝播を停止
  stopPropagation(event) {
    event.stopPropagation()
  }

  // ESCキーで閉じる
  handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }
}
